<template>
  <div>
    <input :id="fg.label" class="toggle toggle-checkbox" type="checkbox" checked>
    <label :for="fg.label" class="lbl-toggle">{{ $filters.capitalize(fg.label) }}</label>
    <div class="collapsible-content">
    <div class="date-slider">

      <Slider v-model="range"
        :tooltips="true"
        :showTooltip="'drag'"
        :tooltipPosition="'bottom'"
        :min="rangeMin"
        :max="rangeMax"
        :lazy="true"
      />


    </div>
    <div class="date-inputs">
      <input class="late-input-l" type="number" v-model.number="range[0]">
      <span class=""> to </span>
      <input class="date-input-r" type="number" v-model.number="range[1]">
      <button class="btn btn-light filter-term date-apply" @click="apply">Apply</button>
    </div>
    </div>
  </div>
</template>

<!-- <style src="@vueform/slider/themes/default.css"></style> -->

<script setup>
  import { ref, getCurrentInstance } from 'vue'
  import Slider from '@vueform/slider'
  import { useFacets } from '../composables/useFacets';

  const instance = getCurrentInstance()
  const $eventBus = instance.appContext.config.globalProperties.$eventBus

  const props = defineProps({
    fg: Object,
    field: String
  })

  const {
    toggleFilterAction,
  } = useFacets()

  const buckets = ref(props.fg.buckets);
  const rangeMin = ref(parseInt(buckets.value[0].key_as_string));
  const rangeMax = ref(parseInt(buckets.value[buckets.value.length-1].key_as_string))
  const range = ref([rangeMin.value, rangeMax.value])

  function apply() {
    const minMaxTimestamps = [
      new Date(range.value[0]).getTime(),
      new Date(range.value[1] + 1).getTime() // +1 to make inclusive of selected year
    ]
    toggleFilterAction(props.fg.field, minMaxTimestamps);
    $eventBus.emit('filter-change');
  }

  $eventBus.on('update-facets', (updated) => {
    if(updated[props.fg.field]?.buckets?.length > 0) {
      buckets.value = updated[props.fg.field].buckets;
      rangeMin.value = parseInt(buckets.value[0].key_as_string);
      rangeMax.value = parseInt(buckets.value[buckets.value.length-1].key_as_string)
      range.value = [rangeMin.value, rangeMax.value]
    }
  })

</script>